import { z } from "zod";

export const ApproverFormSchema = z.object({
  plant: z.string().nonempty("Please select a plant").min(1, "Please select a plant"),
  ruleId: z.string().min(1, "Please select a rule"),  
  approverName: z.string().min(1, "Approver Name is required"),
  approverId: z.string().min(1, "Approver ID is required"),
});


export type ApproverFormSchemaType = z.infer<typeof ApproverFormSchema>;